<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Filter />

    <div class="container">

      <div class="row mt-4 mb-4">
        <div class="col-md-12">
          <div class="d-flex  justify-content-center  align-items-center mb-2">
            <label for="firstColumn" class="custom-label"><strong>Source</strong></label>
          </div>
          <div class="row px-3">
            <div class="col-md-4">
              <div class="form-group">
                <label class="custom-label">Year</label>
                <select class="form-select form-select form-control shadow-none custom-input custom-dropdown"
                  id="yearSelect" v-model="saveData.year">
                  <option value="" disabled selected>Select Option</option>
                  <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
              </div>
            </div>


            <div class="col-md-4">
              <div class="form-group">
                <label class="custom-label">Month</label>
                <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                  v-model="saveData.month">
                  <option value="" disabled selected>Select Option</option>
                  <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="custom-label">File</label>
                <select class="form-select form-control shadow-none form-select custom-input custom-dropdown"
                  v-model="saveData.file" id="autoSizingSelect">
                  <option value="" disabled selected>Select Option</option>
                  <option v-for="file in files" :key="file" :value="file">{{ file.filename }}</option>
                </select>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="row px-3">
        <div class="col-md-12 mb-2">
          <div class="d-flex  justify-content-center  align-items-center mb-2">
            <label for="secondColumn" class="custom-label"><strong>Destination</strong></label>
          </div>

          <div class="row" v-if="!sessionStoragePath">
            <div class="col-md-4">
              <div class="form-group">
                <label class="custom-label">Root</label>
                <select class="form-select form-select form-control shadow-none custom-input custom-dropdown"
                  v-model="saveData.root" id="autoSizingSelect">
                  <option value="" disabled selected>Select Option</option>
                  <option v-for="root in roots" :key="root" :value="root">{{ root.root }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label class="custom-label">Folder Name</label>
                <select class="form-select form-control shadow-none form-select custom-input custom-dropdown"
                  v-model="saveData.folder" id="autoSizingSelect" :disabled="saveData.isfolderenable === 1">
                  <option value="" disabled selected>Select Option</option>
                  <option v-for="folder in folders" :key="folder" :value="folder">{{ folder.folder }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 mt-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input shadow-none" type="checkbox" name="inlineRadioOptions" id="inlineRadio2"
                  :true-value="1" :false-value="0" v-model="saveData.isfolderenable">
                <label class="form-check-label custom-label" for="inlineRadio2">Create a folder if not exist</label>
              </div>

            </div>
          </div>
          <div class="row" v-if="sessionStoragePath">
            <div class="col-md-3">
              <!-- <label for="formFileSm" class="custom-label">Profile Picture</label> -->
              <input class="form-control shadow-none form-control custom-label" id="formFileSm" type="file">
            </div>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-start px-3 mb-3">
        <div class="col-md-12">
          <div class="form-group ">
            <small class="text-danger" style="font-size: 12px;">{{ fileStatusMessage }}</small>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-start px-3 mb-4">
        <div class="col-md-12">
          <div class="form-group ">
            <button class="btn btn-sm btn-primary filter-button me-3" type="button" @click="submitExportData"
              :disabled="isSubmitDisabled">Submit</button>
            <small class="text-danger" style="font-size: 12px;">{{ submitIdFailureMessage }}</small>
            <small class="text-success" style="font-size: 12px;">{{ submitIdMessage }}</small>
          </div>
        </div>
      </div>
      <div class="row px-3 mb-4">
        <label for="firstColumn" class="custom-label mb-2"><strong>View Export Data</strong></label>
        <div class="col-md-12">
          <div class="d-flex align-items-center">
            <div class="col-md-2 me-4">
              <div class="form-group">
                <label class="custom-label">Select Submit ID</label>
                <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                  v-model="selectedSubmitId" @change="fetchViewExportData">
                  <option value="" disabled selected>Select Option</option>
                  <option v-for="submitid in submitIds" :key="submitid" :value="submitid">{{ submitid.submitid }}
                  </option>
                </select>
              </div>
            </div>
            <div class="mt-3 ">
               <svg @click="fetchSubmitIds" v-if="!this.selectedSubmitId" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#1371E7"
                class="bi bi-arrow-clockwise me-5" style="cursor: pointer;" viewBox="0 0 16 13">
                <title>Refresh</title>
                <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
                <path
                  d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
              </svg>
            </div>
            
            <div class="mt-4 col-md-9" v-if="this.selectedSubmitId">
              <label for="assetTypeName" class="custom-label me-5"><strong>Filename: </strong>{{ tableData.filename
              }}</label>


              <label for="assetTypeName" class="custom-label me-5"><strong>Status: </strong>Completed</label>
              
              <svg @click="downloadArchivalReport" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                fill="#1371E7" class="bi bi-download" style="cursor: pointer;" viewBox="0 0 16 14">
                <title>Download</title>
                <path
                  d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                <path
                  d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
              </svg>
            </div>


          </div>
        </div>
      </div>

      <div class="row px-3 py-1" v-if="this.selectedSubmitId">
        <div class="mb-3">
          <table class="table table-hover table-responsive">
            <thead class="table-light">
              <tr>
                <th scope="col">Filename</th>
                <th scope="col">Repository</th>
                <th scope="col">File Type</th>
                <th scope="col">Month</th>
                <th scope="col">Year</th>
                <th scope="col">Start Time</th>
                <th scope="col">End Time</th>

                <!-- <th scope="col">
                <span class="d-flex justify-content-end">
                  <tableHeadingIcon />
                </span>
  
              </th> -->
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ tableData.filename }}</td>
                <td>{{ tableData.repository }}</td>
                <td>{{ tableData.filetype }}</td>
                <td>{{ tableData.month }}</td>
                <td>{{ tableData.year }}</td>
                <td>{{ tableData.starttime }}</td>
                <td>{{ tableData.endtime }}</td>
              </tr>
            </tbody>
          </table>


        </div>
        <!-- <div class="col-md-12 d-flex justify-content-end" >
          <div class="form-group ">
            <button type="button" class="btn btn-danger btn-sm delete-button"
              >Delete</button>
          </div>
        </div> -->
      </div>
    </div>
    <div v-if="loading" class="loading-indicator-report spinner-border spinner-border"></div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Filter from '@/components/Filter.vue';
import { getExportData, ddSubmitId, viewExportData, ddFile, ddFolder, ddRoot, fileStatus, DownloadArchivalReportData } from '@/http/archival/export-data.http'
export default {
  name: 'Export Data',
  components: {
    Header,
    Filter,
  },
  data() {
    return {
      loading: false,
      breadcrumsfirst: "Archival",
      breadcrumslast: "Export Data",
      fileStatusMessage: "",
      submitIds: [],
      tableData: {},
      selectedSubmitId: '',
      submitIdMessage: '',
      submitIdFailureMessage: '',
      timeoutId: null,
      files: [],
      roots: [],
      folders: [],
      sessionStoragePath: 0,
      saveData: {
        file: '',
        root: '',
        folder: '',
        year: '',
        month: '',
        isfolderenable: 1
      }
    }
  },
  computed: {
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 1;
      return Array.from({ length: 8 }, (_, index) => startYear + index);
    },
    months() {
      return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    },
    isSubmitDisabled() {
      const folderNotSelected = !this.saveData.folder && this.saveData.isfolderenable === 0;
      return !this.saveData.month || !this.saveData.year || !this.saveData.file || !this.saveData.root || folderNotSelected;
    }
  },
  mounted() {
    this.fetchSubmitIds();
    this.getDDfetchRootData();
  },
  // watch: {
  //   'saveData.year': 'getDDfetchFileData',
  //   'saveData.month': 'getDDfetchFileData',
  //   'saveData.root': 'getDDfetchFolderData',
  //   'saveData.isfolderenable': function (newValue) {
  //   if (newValue === 1) {
  //     this.saveData.folder = ''; // Clear the selected folder when disabled
  //   }
  // }
  // },
  watch: {
    'saveData.year': function (newValue) {
      this.getDDfetchFileData(); // Fetch files when year changes
      this.callFileStatus();     // Call fileStatus API when year changes
    },
    'saveData.month': function (newValue) {
      this.getDDfetchFileData(); // Fetch files when month changes
      this.callFileStatus();     // Call fileStatus API when month changes
    },
    'saveData.file': function (newValue) {
      this.callFileStatus();     // Call fileStatus API when file changes
    },
    'saveData.folder': function (newValue) {
      if (this.saveData.isfolderenable === 0) {
        this.callFileStatus(); // Call fileStatus API when folder changes
      }
    },
    'saveData.root': function (newValue) {
      this.getDDfetchFolderData(); // Fetch folders when root changes
      this.callFileStatus();      // Call fileStatus API when root changes
    },
    'saveData.isfolderenable': function (newValue) {
      if (newValue === 1) {
        this.saveData.folder = ''; // Clear the selected folder when folder is disabled
      }
      this.callFileStatus();      // Call fileStatus API when isfolderenable changes
    }
  },

  methods: {
    callFileStatus() {
      if ((this.saveData.year && this.saveData.month && this.saveData.file && this.saveData.root && this.saveData.isfolderenable === 1) ||
        (this.saveData.year && this.saveData.month && this.saveData.file && this.saveData.root && (this.saveData.folder && this.saveData.isfolderenable === 0))) {
        const payload = {
          month: this.saveData.month,
          year: String(this.saveData.year),
          file: this.saveData.file ? this.saveData.file.filename : '',
          root: this.saveData.root ? this.saveData.root.root : '',
          folder: this.saveData.folder ? this.saveData.folder.folder : '',
          isfolderenable: this.saveData.isfolderenable ? 1 : 0
        };

        fileStatus(payload)
          .then(response => {
            if (response.isfile === 1) {
              this.fileStatusMessage = "The file already exist. You can process it to overwrite.";
            } else if (response.isfile === 0) {
              this.fileStatusMessage = "";
            }
          })
          .catch(error => {
            console.error('Error fetching file status:', error);
          });
      }

    },

    submitExportData() {
      this.fileStatusMessage = '';
      const payload = {
        month: this.saveData.month,
        year: String(this.saveData.year),
        file: this.saveData.file ? this.saveData.file.filename : '',
        root: this.saveData.root ? this.saveData.root.root : '',
        folder: this.saveData.folder ? this.saveData.folder.folder : '',
        isfolderenable: this.saveData.isfolderenable ? 1 : 0
      };
      getExportData(payload)
        .then((response) => {
          if (response.submitid) {
            this.submitIdMessage = `File Exported and Submit ID is: ${response.submitid}`;
            this.clearMessagesAfterDelay();
          } else {
            this.submitIdFailureMessage = `The system can't find the path specified.`;
            this.clearMessagesAfterDelay();
          }
          return this.fetchSubmitIds();
        })
        .catch((error) => {
          this.error = error.message;
        });
    },
    fetchSubmitIds() {
      ddSubmitId()
        .then((response) => {
          // this.selectedSubmitId = '';
          this.submitIds = response;
        })
        .catch((error) => {
          console.error('Error fetching submit IDs:', error);
        });
    },
    clearMessagesAfterDelay() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        this.submitIdMessage = '';
        this.submitIdFailureMessage = '';
      }, 3000);
    },

    getDDfetchFileData() {
      const payload = {
        year: String(this.saveData.year),
        month: this.saveData.month,
      };
      if (this.saveData.year && this.saveData.month) {
        ddFile(payload).then((response) => {
          if (!response || response.length === 0) {
            this.files = [];
            this.saveData.file = '';
          } else {
            this.files = response
          }
        }).catch((error) => {
          console.log(error)
          this.files = [];
          this.saveData.file = '';
        })
      }

    },
    getDDfetchRootData() {
      ddRoot().then((response) => {
        if (!response || response.length === 0) {
          this.roots = [];
          this.saveData.root = '';
        } else {
          this.roots = response
        }
      }).catch((error) => {
        console.log(error)
        this.roots = [];
        this.saveData.root = '';
      })
    },
    getDDfetchFolderData() {
      const payload = {
        root: this.saveData.root.root,
      };
      if (this.saveData.root) {
        ddFolder(payload).then((response) => {
          if (!response || response.length === 0) {
            this.folders = [];
            this.saveData.folder = '';
          } else {
            this.folders = response
          }
        }).catch((error) => {
          console.log(error)
          this.folders = [];
          this.saveData.folder = '';
        })
      }
    },
    fetchViewExportData() {
      if (this.selectedSubmitId) {
        viewExportData(this.selectedSubmitId)
          .then(response => {
            this.tableData = response
          })
          .catch(error => {
            console.error('Error fetching export data:', error);
          });
      }
    },
    downloadArchivalReport() {
      // if ( !this.selectedPlantName || !this.selectedStartDate || !this.selectedEndDate) return;

      this.loading = true;

      // Ensure your API call sets responseType: 'blob'
      DownloadArchivalReportData({ dir: this.tableData.repository, filename: this.tableData.filename })
        .then(response => {
          const disposition = response.headers?.['content-disposition'] || '';
          let filename = 'export.csv';

          if (disposition) {
            const filenameRegex = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i;
            const matches = filenameRegex.exec(disposition);
            if (matches) {
              filename = decodeURIComponent(matches[1] || matches[2]);
            }
          }

          if (filename.includes('_')) {

            let file_name = ""

            file_name = filename.split('_')

            filename = "export" + "_" + file_name[1] + "_" + file_name[2]
          }
          const blob = new Blob([response.data], { type: 'text/csv' });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('Download failed:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
}
</script>




<style scoped></style>